import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ArrowRightIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
  </svg>
);

const programs = [
  { name: 'Aquatics & Swimming' },
  { name: 'Multi-Sport After School' },
  { name: 'Health & Nutrition Education' },
  { name: 'Fitness & Physical Wellness' },
  { name: 'Youth Leadership Through Sport' },
];

const AsphaltGreenPage = () => (
  <div className="min-h-screen bg-white">
    <Navbar />

    <main id="main-content" className="pt-0">
      {/* Hero */}
      <section
        className="relative pt-36 pb-20 bg-[#00213a] overflow-hidden"
      >
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0"
            style={{ height: '4rem', background: 'linear-gradient(to bottom, rgba(0,33,58,0) 0%, rgba(255,255,255,1) 100%)' }}
            aria-hidden="true"
          />

        <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
              <span className="text-sm font-semibold text-white tracking-tight">Community Partnership</span>
            </div>
          </div>
          <h1 className="text-5xl lg:text-7xl font-semibold text-white mb-6 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
            Asphalt Green
          </h1>
          <p className="text-2xl text-white/90 font-normal max-w-3xl leading-relaxed mb-8 mx-auto">
            Keeping PS 96 students active, healthy, and thriving through world-class sports and fitness programming.
          </p>
          <a
            href="https://www.asphaltgreen.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#00213a] font-semibold rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-sm"
          >
            Visit Asphalt Green Website <ArrowRightIcon />
          </a>
        </div>
      </section>

      {/* About */}
      <section className="max-w-5xl mx-auto px-6 lg:px-8 mb-24 mt-12">
        <div className="bg-white border border-gray-200 rounded-xl shadow-md p-8 lg:p-12">
          <h2 className="text-3xl font-semibold text-gray-900 mb-6 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
            About Asphalt Green
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4 text-lg">
            <strong className="text-gray-900">Asphalt Green</strong> is a leading New York City nonprofit organization dedicated to helping people of all ages lead healthy, active lives. Through sports, fitness, and wellness programs, they serve thousands of young New Yorkers each year.
          </p>
          <p className="text-gray-600 leading-relaxed">
            As a partner of PS 96, Asphalt Green brings high-quality physical education and after-school athletics to our students, giving every Lion the opportunity to discover a love of movement and sport.
          </p>
        </div>
      </section>

      {/* Programs */}
      <section className="max-w-7xl mx-auto px-6 lg:px-8 mb-24">
        <div className="mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#fdbb2e]/5 rounded-lg border border-[#fdbb2e]/20 mb-4">
            <span className="text-sm font-semibold text-[#00213a]">Programs at PS 96</span>
          </div>
          <h2 className="text-4xl font-semibold text-gray-900 mb-4 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
            What Asphalt Green Offers
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((p) => (
            <div key={p.name} className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md hover:border-[#fdbb2e]/20 transition-all duration-200">
              <h3 className="text-lg font-semibold text-gray-900">{p.name}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#00213a] py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-semibold text-white mb-6 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
            Get Moving with Asphalt Green
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Together with Asphalt Green, we're building healthier, stronger Lions.
          </p>
          <a
            href="https://www.asphaltgreen.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#00213a] font-semibold rounded-xl hover:bg-gray-50 transition-colors duration-200 shadow-sm"
          >
            Learn More About Asphalt Green <ArrowRightIcon />
          </a>
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default AsphaltGreenPage;
